<template>
    <app-layout :title="$t('File Storage')">
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                {{ $t('File Storage') }}
            </h2>
        </template>


        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <FileContainerContainer :containers="containers" :active-container="activeContainer"/>
        </div>
    </app-layout>
</template>

<script>
import {defineComponent} from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import FileContainerContainer from '@/Components/FileContainerContainer.vue'

export default defineComponent({
    components: {
        AppLayout,
        FileContainerContainer,
    },

    props: {
        containers: Object,
        activeContainer: Object,
    }
})
</script>
